"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var Dialog = _interopRequireWildcard(require("@radix-ui/react-dialog"));
var _HBCloseButton = _interopRequireDefault(require("../HBCloseButton/HBCloseButton"));
var _ModalInternalContext = require("./ModalInternalContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBModalCloseButton = function HBModalCloseButton(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme;
  var _useModalInternalCont = (0, _ModalInternalContext.useModalInternalContext)(),
    getTestIdProps = _useModalInternalCont.getTestIdProps;
  return /*#__PURE__*/_react["default"].createElement(Dialog.Close, {
    asChild: true
  }, /*#__PURE__*/_react["default"].createElement(_HBCloseButton["default"], (0, _extends2["default"])({
    size: "sm",
    theme: theme,
    distance: 12,
    onClick: null
  }, getTestIdProps('close'))));
};
var _default = exports["default"] = HBModalCloseButton;
//# sourceMappingURL=HBModalCloseButton.js.map